import React, { Component } from "react";
import { InputGroup, Button } from "react-bootstrap";
import Select from 'react-select';
import "../../assets/css/attrib-cards.css";
import { toCardId } from "./AttribCardUtils.js";
import Dictaphone from "../../components/lib/Dictaphone/GcDictaphone.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRandom, faCamera } from "@fortawesome/free-solid-svg-icons";
import GlasschainHttpClient from "../ApiService/GlasschainHttpClient.js";
import he from 'he'


const langOptions = [
  { label: 'english', value: 'en' },
  { label: 'espanol', value: 'es' },
  { label: 'japanese', value: 'ja' },
  { label: 'korean', value: 'ko' },
  { label: 'french', value: 'fr' },
  { label: 'norsk', value: 'no' },
  { label: 'filipino', value: 'tl' },
  { label: 'chinese', value: 'zh-CN' },
  { label: 'chinese (trad)', value: 'zh-TW' },
  { label: 'dutch', value: 'nl' },
  { label: 'persian', value: 'fa' },
  { label: 'polish', value: 'pl' },
  { label: 'swahili', value: 'sw' }
]


export default class AttribTextEditorCard extends Component {
  constructor(props) {
    super(props);

    this.Id = toCardId(this.props.attribTitle);
    this.apiClient = new GlasschainHttpClient();

    this.state = {
      cardState: (this.props.valueBag[this.Id]) ? "touched" : "untouched",
      cardValue: this.props.valueBag[this.Id],
      translateFrom: 'en',
      translateTo: 'es'
    };


    this.renderState = this.renderState.bind(this);
    this.renderUntouchedState = this.renderUntouchedState.bind(this);
    this.renderActiveState = this.renderActiveState.bind(this);
    this.onCardClick = this.onCardClick.bind(this);
    this.onLoseFocus = this.onLoseFocus.bind(this);
    this.onValueChange = this.onValueChange.bind(this);

    this.onTranscriptionChange = this.onTranscriptionChange.bind(this);
    this.translateText = this.translateText.bind(this);
    this.onSourceLangChange = this.onSourceLangChange.bind(this);
    this.onTargetLangChange = this.onTargetLangChange.bind(this);

  }


  componentDidUpdate(prevProps, prevState) {
    let oldVal = prevState.cardValue;
    let newVal = this.props.valueBag[this.Id];
    //console.log("Id: " + this.Id + " Old: " + oldVal + " New: " + newVal);
    if (oldVal !== newVal) {
      this.setState({
        cardValue: newVal
      });
      if (this.state.cardState !== "active") {
        this.setState({ cardState: (newVal) ? "touched" : "untouched" })
      }
    }
  }

  renderCameraIcon =() =>{
    return <FontAwesomeIcon icon={faCamera} color="yellow" size="2x" style={{float: "left", paddingLeft: "5px"}} onClick={(ev) => this.onCameraClick(ev)}/> 
  }

  onCameraClick(ev){
    ev.preventDefault();
    ev.stopPropagation();
    this.props.onRequestCameraDialogOpen(this.Id);
  }

  onSourceLangChange(opt) {
    this.setState({ translateFrom: opt.value })
  }

  onTargetLangChange(opt) {
    this.setState({ translateTo: opt.value });
  }



  async translateText() {
    if ((this.state.cardValue) && (this.state.cardValue !== '')) {
      var translationResponse = await this.apiClient.translate("", this.state.translateTo, this.state.cardValue);
      var newText = he.decode(translationResponse);
      console.log("newText: " + newText);
      this.setState({ cardValue: newText });
      this.props.onValueChange(this.Id, newText);
    }
  }

  onTranscriptionChange(newTranscription) {
    var newValue = (this.state.cardValue) ? this.state.cardValue + " " + newTranscription : newTranscription;
    this.setState({ cardValue: newValue });
    this.props.onValueChange(this.Id, newValue);
  }

  onValueChange(ev) {
    //console.log(ev);
    this.setState({ cardValue: ev.target.value });
    this.props.onValueChange(this.Id, ev.target.value);
  }

  onLoseFocus() {
    var newCardState = (this.state.cardValue) ? "touched" : "untouched";
    this.setState({ cardState: newCardState });
  }

  onCardClick(ev) {
    var newState = "untouched";
    if (this.state.cardState === "active") {
      newState = (this.state.cardValue) ? "touched" : "untouched";
    } else {
      newState = "active";
    }
    this.setState({ cardState: newState });
    this.props.onToggleCard(this);
  }

  renderUntouchedState() {
    return (
      <div className="nonactivecard card-template shadow6 single-center" onClick={this.onCardClick}>
        {this.props.attribTitle}
      </div>
    );
  }


  renderActiveState() {


    let titleTheme = "";
    let theme = "activecard card-template shadow6 textedit-card";
    let textBoxInputType = "";
    let langSelectBox = "commentlangselect"
    let micPosition = "";
    if (this.props.theme) {
      theme = "surveycommentcard";
      titleTheme = "surveyhideelement"
      langSelectBox = "surveycommentlangselect"
      micPosition = "surveycommentmic"
    }
    const translateButton = (this.state.cardValue) ?

      <div style={{ display: "contents", flexDirection: "row" }} className={langSelectBox}>
        <Select
          placeholder={this.state.translateTo}
          value={this.state.translateTo}
          options={langOptions}
          onChange={opt => this.onTargetLangChange(opt)}

        />

        <Button id="translateButton" variant="secondary" onClick={this.translateText}>
          <FontAwesomeIcon id="translate" icon={faRandom} size="2x" color={(this.state.cardValue) ? "lightgreen" : "lightgrey"} />
        </Button>
      </div>
      : <span></span>

    return (
      <div
        className={theme}
      >
        <div onClick={this.onCardClick}>
          <div className={titleTheme}>{this.props.attribTitle}</div>
          {this.renderCameraIcon()}
        </div>
        <Dictaphone
          lang={this.state.translateFrom}
          onTranscriptionChange={this.onTranscriptionChange}
        />
        <div className = {langSelectBox}>
          {translateButton}
          <Select
            placeholder={this.state.translateFrom}
            value={this.state.translateFrom}
            options={langOptions}
            onChange={opt => this.onSourceLangChange(opt)}
          />
        </div>
        <InputGroup size="sm" className="textcard-input">
          <textarea
            rows={5}
            cols={100}
            plainText
            textAlign="center"
            placeholder={this.props.attribTitle}
            aria-describedby="basic-addon2"
            name={this.Id}
            value={this.state.cardValue}
            onChange={this.onValueChange}
          />



        </InputGroup>
      </div>
    );
  }

  renderTouchedState() {
    return (
      <div
        className="nonactivecard card-template touchedcard shadow7 single-center"
        onClick={this.onCardClick}
        style={{ backgroundColor: "lightgreen" }}
      >
        <div style={{ fontSize: "20px" }}>
          {this.props.attribTitle.toUpperCase()}
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            fontColor: "purple",
          }}
        >
          {this.state.cardValue}
        </div>
      </div>
    );
  }

  renderState() {
    if (!this.props.theme) {
      switch (this.state.cardState) {
        case "untouched":
          return this.renderUntouchedState();
        case "touched":
          return this.renderTouchedState();
        default:
          return this.renderActiveState();
      }
    } else {
      return this.renderActiveState();
    }
  }

  render() {
    return this.renderState();
  }
}



